import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownHeader',
    baseStyle: {
      border: `solid 1px ${theme.colors.border}`,
      display: 'flex',
      borderRadius: '9999px',
      backgroundColor: theme.colors.hype.background70,
      gap: theme.space['xs'],
      fontSize: theme.sizes['-1'],
      fontWeight: 500,
      padding: `${theme.space['2xs']} ${theme.space['xs']}`,
      flex: 1,
      height: '100%',

      ['&::placeholder']: {
        color: theme.colors.muted
      }
    }
  };
}
